// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../../../../../types';
import media from '../../../../../../helpers/media';

export const GroupItem = styled<any, Theme>('dt')`
  color: ${props => props.theme.cart.textColor};
  display: flex;
  font-size: .875rem;
  justify-content: space-between;
  line-height: 1.5;

  ${media.lg(css`
    display: ${props => (props.show ? 'flex' : 'none')};
    padding-right: 2rem;
  `)};
`;

export default null;
